/**
 * Converte lista de equipamentos (com geometry WKT) em GeoJSON para uso no Leaflet.
 * Cores por type são aplicadas no estilo da camada (ver getEquipamentColorForType).
 */
import { parseWkt } from './wktParser';

const COR_PADRAO = '#9E9E9E';

export function getEquipamentColorForType(_type) {
  return COR_PADRAO;
}

/**
 * Converte um equipamento (name, type, geometry WKT) em uma ou mais features GeoJSON.
 * @param {{ id: number, name: string, type: string, geometry: string }} item
 * @returns {Array<import('geojson').Feature>}
 */
function equipamentToFeatures(item) {
  const parsed = parseWkt(item.geometry);
  const props = { ...item };
  const features = [];

  if (parsed.type === 'MULTILINESTRING' && parsed.lines?.length) {
    if (parsed.lines.length === 1) {
      features.push({
        type: 'Feature',
        properties: props,
        geometry: { type: 'LineString', coordinates: parsed.lines[0] },
      });
    } else {
      features.push({
        type: 'Feature',
        properties: props,
        geometry: { type: 'MultiLineString', coordinates: parsed.lines },
      });
    }
  } else if ((parsed.type === 'MULTIPOLYGON' || parsed.type === 'POLYGON') && parsed.polygons?.length) {
    const coords = parsed.polygons.map((ring) => [ring]);
    if (coords.length === 1 && coords[0].length === 1) {
      features.push({
        type: 'Feature',
        properties: props,
        geometry: { type: 'Polygon', coordinates: coords[0] },
      });
    } else {
      features.push({
        type: 'Feature',
        properties: props,
        geometry: { type: 'MultiPolygon', coordinates: coords },
      });
    }
  }
  return features;
}

/**
 * Converte lista de equipamentos em GeoJSON FeatureCollection para L.geoJSON.
 * @param {Array<{ id: number, name: string, type: string, enabled?: boolean, geometry: string }>} list
 * @returns {{ type: 'FeatureCollection', features: Array }}
 */
export function equipamentsToGeoJSON(list) {
  const features = [];
  (list || []).forEach((item) => {
    if (!item.geometry) return;
    equipamentToFeatures(item).forEach((f) => features.push(f));
  });
  return { type: 'FeatureCollection', features };
}
